import styles from './styles';
import Pressable from '../Pressable';
import Text from '../Text';
import PrivateText from '../PrivateText';
import PropTypes from 'prop-types';

const Link = ({
  style,
  disabled,
  textStyle,
  private: isPrivate,
  children,
  onPress,
}) => {
  const LinkText = isPrivate ? PrivateText : Text;

  if (disabled) {
    return <LinkText style={[styles.disabled, textStyle]}>{children}</LinkText>;
  }

  return (
    <Pressable allowBubbling style={style} onPress={onPress}>
      <LinkText style={[styles.link, textStyle]}>{children}</LinkText>
    </Pressable>
  );
};
Link.propTypes = {
  style: PropTypes.any,
  disabled: PropTypes.any,
  textStyle: PropTypes.any,
  private: PropTypes.any,
  children: PropTypes.any,
  onPress: PropTypes.any,
};

export default Link;
